import { useMutation } from '@tanstack/react-query';
import useSlingApi from '@sdk/api/useSlingApi';

import { useConversationQueryCache } from '@web/conversations/hooks/useConversationQueryCache';

export const useMuteConversation = () => {
  const { muteConversation } = useConversationQueryCache();
  const { conversation } = useSlingApi();

  const mutation = useMutation({
    mutationFn: (payload: IDObject) => conversation.mute(payload.id),
    onSuccess: (conversation, payload) => {
      muteConversation(payload.id);
    },
  });

  return mutation;
};
